import {Carousel, Col, Flex, Image, Row, Tabs} from "antd"
import Title from "antd/lib/typography/Title";
import Paragraph from "antd/lib/typography/Paragraph";
import {useTranslations} from "next-intl";
import React, {CSSProperties, ReactNode} from "react";
import {CheckCircleOutlined, FileDoneOutlined, FormOutlined, WifiOutlined} from "@ant-design/icons";
import Icon from '@ant-design/icons';
import Leaf from "@/public/assets/svg/leaf.svg";
import Bed from "@/public/assets/svg/bed-queen.svg";
import {ThemeColors} from "@/src/entities/colors";
import {ThemeService} from "@/src/services/theme";

type Props = {
    selectedTab: string
    onSelectTab: (activeKey: string) => void
};
const CompanyComponent = (props: Props) => {

    const localization = useTranslations("company")
    const themeColors = ThemeService.getThemeColors()
    const imageStyle: CSSProperties = { fontSize: '48px', color: `${themeColors.menuBarColor}`}

    const getTabContent = (imagePath: string, text: string, points: string[]) => {
        return (
            <Row gutter={16}>
                <Col xs={12} >
                    <Image preview={false} src={imagePath} alt="" style={{width: "95%", border: "1px solid transparent", borderRadius: 8}} />
                </Col>
                <Col xs={12}>
                    <Paragraph>{text}</Paragraph>
                    <ul style={{listStyle: "none"}}>
                        {(()=> {
                            return points.map((point, index) => {
                                return (<li key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "10px 0 0"}}><CheckCircleOutlined style={{color: themeColors.primary, fontSize: 16, marginRight: 10}}/>{point}</li>)
                            })
                        })()}
                    </ul>
                </Col>
            </Row>
        )
    }

    const slideImages = () => {
        var slides = []
        for (let i= 1; i < 23; i++) {
            slides.push({image: `/assets/about/${i}.jpg`})
        }
        return slides
    }

    const retrieveServices = () => {
        return [
            { image: <FormOutlined style={imageStyle} />, title: localization("title1"), text: localization("contentText1")},
            { image: <Icon component={Bed} style={imageStyle} />, title: localization("title2"), text: localization("contentText2")},
            { image: <WifiOutlined style={imageStyle} />, title: localization("title3"), text: localization("contentText3")},
            { image: <Icon component={Leaf} style={imageStyle} />, title: localization("title4"), text: localization("contentText4")}
        ]
    }

    return (
        <div style={{padding: "50px 0"}}>
            <Row gutter={16} style={{margin: 0}}>
                <Col xs={24} sm={24} md={24} lg={12} style={{textAlign: "center"}}>
                    <Carousel infinite autoplay dots={false} draggable autoplaySpeed={3500} effect={"scrollx"} style={{ border: "1px solid transparent", borderRadius: 15, overflow: "hidden", padding: 0, maxWidth:"100%", marginBottom: 10}}>
                        {(() => {
                            return slideImages().map((value, index) => {
                                return  <Image key={index} preview={false} src={value.image} alt="" />
                            })
                        })()}
                    </Carousel>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                    <Title level={1} style={{textAlign: "left", letterSpacing: -2, fontSize: 38}}>{localization("title")}</Title>
                    <Paragraph style={{fontSize: 16}}>{localization("subtitle")}</Paragraph>
                    <Row gutter={16}>
                        {(() => {
                            return retrieveServices().map((value, index) => {
                                return <Col xs={24} sm={24} md={12} lg={12} key={index}>
                                    <Flex vertical={false} gap={16} justify={"center"} align={"flex-start"}>
                                        {value.image}
                                        <Flex vertical>
                                            <Title level={4}>{value.title}</Title>
                                            <Paragraph>{value.text}</Paragraph>
                                        </Flex>

                                    </Flex>
                                </Col>
                            })
                        })()}
                    </Row>
                </Col>
            </Row>
        </div>
    )

}

export default CompanyComponent